import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { QRCodeModule } from 'angularx-qrcode';
import { TranslocoModule } from '@ngneat/transloco';
import { ShowQrCodeComponent } from './show-qr-code.component';

@NgModule({
  declarations: [ShowQrCodeComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    QRCodeModule,
    TranslocoModule
  ],
  exports: [ShowQrCodeComponent]
})
export class ShowQrCodeModule {}
